<script>
import { Sketch } from 'vue-color'
var colors = {
  hex: '#FFFFFF',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 1,
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.3,
    a: 1,
  },
  rgba: {
    r: 25,
    g: 77,
    b: 51,
    a: 1,
  },
  a: 1,
}
export default {
  components: {
    'sketch-picker': Sketch,
  },
  props: {
    color: { type: String, default: '' },
  },
  data() {
    return {
      colors,
      bgColor: '#FFFFFF',
      displayPicker: false,
    }
  },

  methods: {
    updateValue: function(value) {
      this.colors = value
      this.bgColor = this.colors.hex
    },

    showPicker: function() {
      document.addEventListener('click', this.documentClick)
      this.displayPicker = true
    },

    hidePicker: function() {
      document.removeEventListener('click', this.documentClick)
      this.displayPicker = false
    },

    documentClick: function(e) {
      var el = this.$refs.colorpicker
      var target = e.target
      if (el !== target && !el.contains(target)) {
        this.hidePicker()
      }
    },
  },
}
</script>

<template>
  <div class="input-group color-picker">
    <b-input-group ref="colorpicker" class="mt-3">
      <b-input-group-text slot="prepend">Background</b-input-group-text>
      <b-form-input
        readonly
        :style="{ 'background-color': bgColor }"
        @focus.native="showPicker"
      >
      </b-form-input>
    </b-input-group>
    <sketch-picker
      v-if="displayPicker"
      :value="colors"
      :class="$style.colorPosition"
      @input="updateValue"
    ></sketch-picker>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.colorPosition {
  position: absolute !important;
  top: 50px;
  left: 0;
  z-index: 999;
}
</style>
